(function () {
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6d13"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6d13"] = parcelRequire;
}
parcelRequire.register("aD989", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $7bd4a10858a5297b$export$6503ec6e8aabbaf; }, function (v) { return $7bd4a10858a5297b$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $7bd4a10858a5297b$export$f7ad0328861e2f03; }, function (v) { return $7bd4a10858a5297b$export$f7ad0328861e2f03 = v; });
var $7bd4a10858a5297b$export$6503ec6e8aabbaf;
var $7bd4a10858a5297b$export$f7ad0328861e2f03;
"use strict";
var $7bd4a10858a5297b$var$mapping = {};
function $7bd4a10858a5297b$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$7bd4a10858a5297b$var$mapping[keys[i]] = pairs[keys[i]];
}
function $7bd4a10858a5297b$var$resolve(id) {
    var resolved = $7bd4a10858a5297b$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$7bd4a10858a5297b$export$6503ec6e8aabbaf = $7bd4a10858a5297b$var$register;
$7bd4a10858a5297b$export$f7ad0328861e2f03 = $7bd4a10858a5297b$var$resolve;

});

var $8f7d4f5ffe9f6759$exports = {};

(parcelRequire("aD989")).register(JSON.parse('{"drLhz":"index.c60bfe32.js","lsyMT":"somethingWentWrong.20987337.svg","fS7Z5":"request_pending.a64b3804.svg","jwFlf":"bulb.88a3a48b.svg","fPiYR":"success.255bcde6.svg","d4q8k":"redirecting.7f187ce7.svg","cFatK":"techFail.ce045dfd.svg","dndQ5":"pledgeFail.5ba961d4.svg","bsCuP":"authFail.d58ad39b.svg","h53mu":"nsdl_redirection.648e45c8.svg","caLSw":"service_not_available.92e2058a.svg","8fkFl":"linkToDdpi.3671be87.svg","fFAz6":"percentage.5f07d226.svg","iyZY6":"lock.81f7208f.svg","8Rpzp":"instantly.d5038376.svg","3Fca2":"SendRequestToDepository.Page.9cbdb5a4.js","c8uQV":"SendRequestToDepository.Page.73a9142e.js","1poGa":"SendRequestToDepository.Page.f6902928.js","cKPoI":"ShowRequestStatus.Page.3627ae71.js","2kfqJ":"ValidateSSO.Page.68dcb6d7.js","8JvYF":"RedirectToLogin.Page.27f7f742.js","4nlqC":"RedirectToInitiator.Page.f237a1fd.js","gx2Ml":"ServiceNotAvailable.Page.dc117588.js","dAxc6":"EodDowntime.Page.f0008420.js","dbe0C":"service-worker.js"}'));

})();
//# sourceMappingURL=index.7bbf189e.js.map
